import React, { Component } from 'react';
import App_data from '../../config/App_data';
import FD from '../../RestAPI/fetchData';
// import StarRatingComponent from 'react-star-rating-component';
// import StarRatings from 'react-star-ratings';
import cjquery from 'jquery';
import Cfa2SubscriptionCheck from '../../RestAPI/Cfa2Subscription';
import PartnerCfa2SubscriptionCheck from '../../RestAPI/PartnerSubscription/Cfa2Subscription';
import language from '../../../assets/languages/language';
import { Tooltip, Col, Row } from 'reactstrap';
import ModalComponent from '../../Common/Modal';
import AlertMessage from '../../config/alertMessage';
// import { getDeviceDetails } from "../../../../common/deviceDetails";
// import GD from '../../RestAPI/getData';
import { getIpAddress } from '../../../common/getIpAddress';
import ValidateSaveReportIcon from '../../Common/ValidateSaveReportIcon';
import AppRoutes from '../../config/AppRoutes';
import { EXAM_NAMES, examNameAccordingToDB } from '../../../common/constant';
import FlashCard from '../../../components/FlashCard';
import { isRevisionModeActive, renderHTMLContent } from '../../../common/function';
import ViewQuestion from '../../../Components-2025/QuestionBank/ViewQuestion';
import userStore from "../../../store/userStore";
import { questionDisplayNumber, resolveQuestionNumber } from '../../../common/cfa2QuestionNumbering';
/* eslint-disable*/
class Cfa22023chapter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      successAlert: false,
      alert_status: false,
      MessageTitle: App_data.messageTitle,
      MessageContent: AlertMessage.messageContent_cfa_2,
      questions: [],
      all_questions_state: [],
      token: '',
      idname: '',
      ValidToken: false,
      reportLoading: false,
      chapter_id: '',
      offset: 0,
      limit: 1,
      choice_a: 'answer_box',
      choice_b: 'answer_box',
      choice_c: 'answer_box',
      result_block: 'card hide_block',
      report_block: 'card hide_block',
      clicked: false,
      choice: '',
      result: '',
      text_color: 'card-header',
      records: '',
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      bookmarkColor: '',
      flagCSS: 'fa fa-flag-o mark-action-btn',
      timerstopbtn: 'pause_btn icon-control-pause',
      save_text: `${language.LC().SAVE_QUESTION}`,
      savedQuestion: false,
      comment: 'card-block',
      flashcard: 'card-block',
      comment_data: '',
      flash_data: [],
      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
      comment_arrow: '',
      flash_card_arrow: '',
      flash_class: 'edit_right_padding',
      count: 0,
      rating: 0,
      rated: false,
      ratting_text: `${language.LC().RATE_THIS_QUESTION}`,
      validated: false,
      comment_update: 'hide_block',
      comment_save: 'btn btn-primary active pointer_class margin_bottom_20',
      comment_update_id: '',
      next_block: '',
      previ_block: '',
      question_length: '',
      timer_stop: false,
      timer_tag: 'Stop',
      timerstopbtn: 'pause_btn icon-control-pause',
      chaptername: '',
      caseid: this.props.params.caseid,
      all_cases: [],
      cases_display: '',
      cases_name: '',
      isFlashCardHidden: true,
      cases_length: '',
      case_id: '',
      cases_offset: '',
      casesquestion_length: '',
      chapters: '',
      display_loader: '',
      selectedmenu: 'cfa_2',
      subscriptionstatus: '',
      display_subcription: 'hide_block',
      display_cases: 'show_block',
      showCompletionQuestion: false,
      markAsCompleted: false,
      markAsNotCompleted: false,
      markCompleted: true,
      cases: [],
      exam_type: 'cfa_2',
      cfaUnlimitedPackage: '',
      cfaUnlimitedActiveExam: '',
      forumComment: '',
      category: 'CFA Level 2 2023',
      tags: ['cfa-2-2023', 'cfa', 'question', 'case'],
      tooltips: [
        {
          placement: `${language.LC().COMMENT_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
        {
          placement: `${language.LC().REPORT_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
        {
          placement: `${language.LC().FLASHCARD_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
      ],
      user_city: '',
      user_country: '',
      user_ip: '',
      user_state: '',
      user_continent: '',
      selectedChoice: '',
      timeDone: 0,
    };
    this.childRef = null;
    this.setChildRef = element => {
      this.childRef = element;
    };
    this.toggleAlert = this.toggleAlert.bind(this);
    this.timerValue = 0;
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  async componentDidMount() {
    window.scrollTo(0, 0);
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      token: storage_session['token'],
      idname: storage_session['idname'],
    });
    const result = await getIpAddress();
    if (result) {
      this.setState({
        user_city: result.city,
        user_country: result.country,
        user_ip: result.query,
        user_state: result.region,
        user_continent: result.continent,
      });
    }
    this.setState({
      case_id: this.props.params.caseid,
      display_cases: 'hide_block',
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };
    // FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
      var data = {
        token: storage_session['token'],
        idname: storage_session['idname'],
        caseid: this.props.params.caseid,
      };
      FD.callAPI(App_data.backend_api + '/cfa_2_2025question_bank/getCasesbyId', data).then(
        resp_cases => {
          this.setState({ cases: resp_cases });
          if (resp_cases.success) {
            var data = {
              token: storage_session['token'],
              idname: storage_session['idname'],
            };
            // FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
            userStore.getUserProfile(true).then(resp => {
              var free_status = '';

              if (resp.profileInfo.role === 'partner') {
                if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
                  free_status = 'free';
                  this.setState({ subscriptionstatus: 'free' });
                  if (resp_cases.casesingleData.free == 0) {
                    this.setState({
                      display_cases: 'hide_block',
                      display_subcription: 'show_block',
                    });
                    this.toggleAlert();
                  } else {
                    this.setState({
                      display_cases: 'show_block',
                      display_subcription: 'hide_block',
                    });
                  }
                } else {
                  this.setState({
                    cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
                    cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
                  });
                  var data_arr = resp.profileInfo.exam_selected
                    ? JSON.parse(resp.profileInfo.exam_selected)
                    : null;
                  var dataset = {
                    token: storage_session['token'],
                    idname: storage_session['idname'],
                    examid: data_arr,
                  };
                  FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
                    async resp_exam => {
                      if (resp_exam.success) {
                        var exam_data = resp_exam.examData;
                        var selectedmen = this.state.selectedmenu;
                        var isInArray_var = false;
                        const examPlanData = resp_exam.examPlan[0];
                        isInArray_var = await PartnerCfa2SubscriptionCheck.checkCfa2Subscription(
                          selectedmen,
                          exam_data,
                          this.state.cfaUnlimitedPackage,
                          this.state.cfaUnlimitedActiveExam,
                          examPlanData,
                        );
                        if (isInArray_var) {
                          this.setState({
                            subscriptionstatus: 'paid',
                            display_cases: 'show_block',
                            display_subcription: 'hide_block',
                          });
                        } else {
                          if (resp_cases.casesingleData.free == 0) {
                            this.setState({
                              display_cases: 'hide_block',
                              display_subcription: 'show_block',
                            });
                          } else {
                            this.setState({
                              subscriptionstatus: 'free',
                              display_cases: 'show_block',
                              display_subcription: 'hide_block',
                            });
                          }
                        }
                      }
                    },
                  );
                }
              } else {
                if (
                  resp.profileInfo.exam_selected == '' &&
                  resp.profileInfo.cfaUnlimitedPackage == '' &&
                  resp.profileInfo.cfaUnlimitedActiveExam == ''
                ) {
                  free_status = 'free';
                  this.setState({ subscriptionstatus: 'free' });
                  if (resp_cases.casesingleData.free == 0) {
                    this.setState({
                      display_cases: 'hide_block',
                      display_subcription: 'show_block',
                    });
                    this.toggleAlert();
                  } else {
                    this.setState({
                      display_cases: 'show_block',
                      display_subcription: 'hide_block',
                    });
                  }
                } else {
                  this.setState({
                    cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
                    cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
                  });
                  var data_arr = resp.profileInfo.exam_selected
                    ? JSON.parse(resp.profileInfo.exam_selected)
                    : null;
                  var dataset = {
                    token: storage_session['token'],
                    idname: storage_session['idname'],
                    examid: data_arr,
                  };
                  FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
                    resp_exam => {
                      if (resp_exam.success) {
                        var exam_data = resp_exam.examData;
                        var selectedmen = this.state.selectedmenu;
                        var isInArray_var = false;
                        isInArray_var = Cfa2SubscriptionCheck.checkCfa2Subscription(
                          selectedmen,
                          exam_data,
                          this.state.cfaUnlimitedPackage,
                          this.state.cfaUnlimitedActiveExam,
                        );
                        if (isInArray_var) {
                          this.setState({
                            subscriptionstatus: 'paid',
                            display_cases: 'show_block',
                            display_subcription: 'hide_block',
                          });
                        } else {
                          if (resp_cases.casesingleData.free == 0) {
                            this.setState({
                              display_cases: 'hide_block',
                              display_subcription: 'show_block',
                            });
                          } else {
                            this.setState({
                              subscriptionstatus: 'free',
                              display_cases: 'show_block',
                              display_subcription: 'hide_block',
                            });
                          }
                        }
                      }
                    },
                  );
                }
              }
            });
          }
        },
      );
    // });

    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      chapter_id: this.props.params.chapterid,
    };
    FD.callAPI(App_data.backend_api + '/cfa_2_2025question_bank/getChaptersbyID', data).then(
      resp => {
        if (resp.success) {
          this.setState({
            chaptername: resp.chapterdata.chapter_name,
            chapters: resp.chapterdata,
          });
        } else {
          this.setState({ ValidToken: false });
        }
      },
    );
    FD.callAPI(App_data.backend_api + '/cfa_2_2025question_bank/getCases', data).then(resp => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          all_cases: resp.readings,
          cases_length: resp.readings.length,
        });
        for (var i = 0; i < resp.readings.length; i++) {
          if (this.props.params.case_offset == i) {
            this.setState({
              cases_offset: this.props.params.case_offset,
              cases_display: resp.readings[i].case,
              cases_name: resp.readings[i].case_name_2025,
            });
          }
        }
        var param = {
          token: storage_session['token'],
          idname: storage_session['idname'],
          case_id: this.state.case_id,
        };
        FD.callAPI(App_data.backend_api + '/cfa_2_2025question_bank/getCasesquestion', param).then(
          resp_question => {
            if (resp_question.success) {
              this.setState({
                casesquestion_length: resp_question.questions_details.length,
              });
              if (resp_question.questions_details.length > 0) {
                const wantedNumber = resolveQuestionNumber(
                  resp_question.questions_details,
                  this.props.params.question_number,
                );
                let offset_res = '';
                var questionid = '';
                for (var i = 0; i < resp_question.questions_details.length; i++) {
                  if (
                    resp_question.questions_details[i].question_number == wantedNumber
                  ) {
                    offset_res = i;
                    questionid = resp_question.questions_details[i].id;
                    const currentQuestion = resp_question.questions_details[i];
                    const selectedChoice = currentQuestion["cfa2_2025_question_stats.selected_choice"] || '';
                    const rightAnswer = currentQuestion["cfa2_2025_question_stats.right_answer"] || '';
                    const answerStatus = currentQuestion["cfa2_2025_question_stats.id"] || '';
                    const timeDone = currentQuestion["cfa2_2025_question_stats.time_done"] || 0;
                    const correctChoiceKey = 'answer';
                    const { selected, showAnswer } = this.determineSelectedAndShowAnswer(currentQuestion, selectedChoice, answerStatus, rightAnswer, correctChoiceKey);

                    this.updateTimerState(selected, timeDone);

                    const choiceKeys = ['choice_a', 'choice_b', 'choice_c'];
                    const choiceBoxStates = choiceKeys.reduce((acc, choice) => {
                      const isSelected = selected === choice;
                      const isCorrect = `choice_${currentQuestion[correctChoiceKey]}` === choice;
                      acc[choice] = isSelected
                        ? (isCorrect ? 'answer_box success' : 'answer_box failure')
                        : (isCorrect ? 'answer_box success' : 'answer_box');
                      return acc;
                    }, {});

                    this.setState({
                      questions: currentQuestion,
                      selectedChoice: selected,
                      clicked: !!selected,
                      ...choiceBoxStates,
                      result_block: showAnswer ? 'card show_block' : 'card hide_block',
                      text_color: selected === `choice_${currentQuestion[correctChoiceKey]}` ? 'card-header text_success' : 'card-header text_failure',
                      result: selected === `choice_${currentQuestion[correctChoiceKey]}` ? 'CORRECT' : 'INCORRECT',
                      display_loader: 'hide_block',
                    });
                    this.handleTimerResponse(selected);
                  }
                }
                this.setState({
                  offset: offset_res,
                  all_questions_state: resp_question.questions_details,
                });

                var params_fav = {
                  token: storage_session['token'],
                  question_id: questionid,
                  idname: storage_session['idname'],
                  chapter_id: this.props.params.chapterid,
                };

                FD.callAPI(
                  `${App_data.backend_api}/cfa_2_2025question_bank/getFavQuestions`,
                  params_fav,
                ).then(response => {
                  if (response.success) {
                    this.setState({
                      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
                      bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
                      bookmarkColor: 'rgb(54, 141, 84)',
                      save_text: `${language.LC().Question_Saved}`,
                      isFlashCardHidden: false,
                    });
                  } else {
                    this.setState({ isFlashCardHidden: true });
                  }
                });

                var params = {
                  token: storage_session['token'],
                  question_id: questionid,
                  idname: storage_session['idname'],
                };
                FD.callAPI(
                  App_data.backend_api + '/cfa_2_2025question_bank/getCfaratting',
                  params,
                ).then(response => {
                  if (response.success) {
                    this.setState({ rated: true });
                    response.ratting.map(items => {
                      this.setState({
                        rating: items.ratting,
                        ratting_text: 'Rated ',
                      });
                    });
                  }
                });

                var params = {
                  token: storage_session['token'],
                  idname: storage_session['idname'],
                  question_id: questionid,
                };
                FD.callAPI(
                  App_data.backend_api + '/cfa_2_2025question_bank/getFlashcards',
                  params,
                ).then(response => {
                  if (response.success) {
                    this.setState({ ValidToken: true });
                    if (response.flash_cards.length > 0) {
                      this.setState({
                        flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
                      });
                      var flash_cards = response.flash_cards.map((items, index) => (
                        <li key={index}>
                          <div className=''>
                            <ul className='icon_list'>
                              <li>
                                <a className='pointer_class' onClick={this._editFlash.bind(this, items)}>
                                  <i className='fa fa-pencil' />
                                </a>
                              </li>
                              <li>
                                <a
                                  className='pointer_class'
                                  onClick={this._deleteFlash.bind(this, items)}
                                >
                                  <i className='fa fa-close' />
                                </a>
                              </li>
                            </ul>
                            <div className={this.state.flash_class}>
                              <h4 />
                              <p>{items.flash_card}</p>
                            </div>
                          </div>
                        </li>
                      ));
                    } else {
                      this.setState({
                        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
                      });
                      var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
                    }
                    this.setState({ flash_data: flash_cards });
                  } else {
                    var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
                    this.setState({
                      ValidToken: false,
                      flash_data: flash_cards,
                      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
                    });
                  }
                  return response;
                });

                this.setState({ records: '' });
              }
            }
          },
        );
      } else {
        this.setState({ ValidToken: false, records: 'Result not found.' });
      }
      this.setState({ display_loader: 'hide_block' });
      clearInterval(this.timer);
      this.timer = setInterval(this.tick, 1000);
      return resp;
    }).catch(err => {
      this.setState({ display_loader: 'hide_block' });
    });

    this.timer = setInterval(this.tick, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  saveForumComment(e) {
    this.setState({ forumComment: e.target.value });
  }

  changeCompletionStatus(e) {
    e.preventDefault();
    if (this.state.markAsCompleted == true) {
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        case_no: this.state.cases.casesingleData.case_number,
        completion_status: this.state.markAsCompleted,
        exam_type: this.state.exam_type,
        chapter_id: this.props.params.chapterid,
      };
      FD.callAPI(App_data.backend_api + '/cfa_2_2025question_bank/updateCases', data).then(resp => {
        if (resp.success) {
          this._getReadings();
        }
      });
    } else {
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        case_no: this.state.cases.casesingleData.case_number,
        completion_status: this.state.markAsCompleted,
        exam_type: this.state.exam_type,
        chapter_id: this.props.params.chapterid,
      };
      FD.callAPI(App_data.backend_api + '/cfa_2_2025question_bank/updateCases', data).then(resp => {
        if (resp.success) {
          this._getReadings();
        }
      });
    }
  }

  markCompleted() {
    this.setState({
      markAsCompleted: true,
      markAsNotCompleted: false,
      markCompleted: false,
    });
  }

  markNotCompleted() {
    this.setState({
      markAsCompleted: false,
      markAsNotCompleted: true,
      markCompleted: false,
    });
  }

  goPremium() {
    this.context.router.push({
      pathname: '/Subscribe/',
      state: {
        token: this.state.token,
        idname: this.state.idname,
        selectedMenu: this.state.selectedmenu,
      },
    });
  }
  toggleAlert() {
    this.setState({
      alert_status: !this.state.alert_status,
    });
  }

  tick = () => {
    if (!this.state.timer_stop) {
      this.setState(prevState => ({
        count: prevState.count + 1
      }));
    }
  }

  /*
  -------------------------------------------------
    Function to redirect page to readings page
  -------------------------------------------------
  */
  _getReadings = () => {
    this.context.router.push({
      pathname: AppRoutes.CFA2_2025_QUESTION_BANK_CASES.replace(
        ':id',
        this.props.params.chapterid,
      ).replace(':chapter_name', this.state.chaptername),
      // `/cfa2_cases/${this.props.params.chapterid}/${
      //   this.state.chaptername
      // }`,
      // state: {
      //   token: this.state.token,
      //   idname: this.state.idname,
      //   chapter: this.state.chapters,
      // },
    });
  };

  _getAnswer = (choice, e) => {
    const currentQuestionId = this.state.questions.id;
    const selectedChoice = choice[0];

const choiceKeys = ['choice_a', 'choice_b', 'choice_c', 'choice_d', 'choice_e'];
const updatedChoices = {};

choiceKeys.forEach(key => {
  updatedChoices[key] = selectedChoice === key ? 'answer_box clicked_box' : 'answer_box';
});

this.setState(
  {
    selectedChoice,
    setAnswer: true,
    clicked: false,
    showAnswer: false,
    stopTimer: false,
    ...updatedChoices,
  },
  () => {
    const currentAttempts = this.state.attemptedQuestions || {};
    const updatedAttempts = {
      ...currentAttempts,
      [currentQuestionId]: {
        selectedChoice: selectedChoice,
        isAnswered: false,
        setAnswer: true,
      },
    };

    this.setState({ attemptedQuestions: updatedAttempts });
  }
);

    var data = {
      token: this.state.token,
      idname: this.state.idname,
      id: this.props.params.id,
      city: this.state.user_city,
      country: this.state.user_country,
      state: this.state.user_state,
      continent: this.state.user_continent,
      ip: this.state.user_ip,
    };
    FD.callAPI(App_data.backend_api + '/cfa_2_2025question_bank/trackUserRecord', data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true });
      }
    });
  };


  getResult = (item, e) => {
    const {
      selectedChoice,
      timer,
      count,
      attemptedQuestions,
      validated,
      token,
      idname
    } = this.state;
    if (selectedChoice) {
      if (timer) {
        clearInterval(timer);
        this.timer = null;
      }

      const currentQuestionId = item.id;
      const correctChoiceKey = item['answer'];
      const isCorrect = selectedChoice === `choice_${correctChoiceKey}`;
      const timeDone = item["cfa2_2025_question_stats.time_done"] || count;

      this.setState({
        timer_stop: true,
        timer_tag: 'Start',
        timerstopbtn: 'pause_btn icon-control-play',
        setAnswer: true,
        clicked: true,
        showAnswer: true,
        stopTimer: true,
        result_block: 'card show_block',
        result: isCorrect ? 'CORRECT' : 'INCORRECT',
        text_color: isCorrect ? 'card-header text_success' : 'card-header text_failure'
      }, () => {
        const currentAttempts = attemptedQuestions || {};
        const updatedAttempts = {
          ...currentAttempts,
          [currentQuestionId]: {
            selectedChoice: selectedChoice,
            isAnswered: true,
            isCorrect: isCorrect,
            setAnswer: true,
            timeSpent: timeDone
          }
        };

        this.setState({ attemptedQuestions: updatedAttempts });

        if (!validated) {
          var data = {
            token: token,
            idname: idname,
            question_id: currentQuestionId,
            right_answer: isCorrect ? 1 : 0,
            time_done: timeDone,
            selected_choice: selectedChoice,
          };

          FD.callAPI(`${App_data.backend_api}/cfa_2_2025question_bank/saveStats`, data).then(resp => {
            if (resp.success) {
              this.setState({ ValidToken: true, validated: true });
            } else {
              this.setState({ ValidToken: false });
            }
            return resp;
          });
        }
      });
    } else {
      this.setState({
        result_block: 'card hide_block'
      });
    }
  };

  _timer_funct = (item, e) => {
    if (this.state.clicked || this.state.validated) {
      return;
    }
    if (this.state.timer_stop) {
      this.setState({
        timer_stop: false,
        timer_tag: 'Stop',
        timerstopbtn: 'pause_btn icon-control-pause',
      });
      clearInterval(this.timer);
      this.timer = setInterval(this.tick, 1000);
    } else {
      this.setState({
        timer_stop: true,
        timer_tag: 'Start',
        timerstopbtn: 'pause_btn icon-control-play',
      });
      clearInterval(this.timer);
      this.timer = null;
    }
  };

  /*
  ------------------------------------------------------------------------
     Function to Display Saved Question on button and save in database
  -------------------------------------------------------------------------
    */
  _saveQuestion = (item, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.id,
      chapter_id: this.props.params.chapterid,
    };
    if (this.state.bookmarkCSS == 'fa fa-bookmark mark-action-btn-bookmark') {
      FD.callAPI(App_data.backend_api + '/cfa_2_2025question_bank/unsaveQuestion', data).then(
        resp => {
          if (resp.success) {
            if (this.childRef) {
              this.childRef.deleteFlash();
            }
            this.setState({
              ValidToken: true,
              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
              bookmarkColor: '',
              save_text: `${language.LC().SAVE_QUESTION}`,
              isFlashCardHidden: true,
            });
          } else {
            this.setState({ ValidToken: false });
          }
          return resp;
        },
      );
    } else {
      FD.callAPI(App_data.backend_api + '/cfa_2_2025question_bank/saveQuestion', data).then(
        resp => {
          if (resp.success) {
            this.setState({
              ValidToken: true,
              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
              bookmarkColor: 'rgb(54, 141, 84)',
              save_text: `${language.LC().Question_Saved}`,
              isFlashCardHidden: false,
            });
          } else {
            this.setState({ ValidToken: false, isFlashCardHidden: true });
          }
          return resp;
        },
      );
    }
  };

  /*
  -------------------------------------
    Function to give star rattings
  -------------------------------------
    */
  onStarClick(item, nextValue, prevValue, name) {
    if (prevValue != nextValue);
    {
      var params = {
        token: this.state.token,
        idname: this.state.idname,
        question_id: item.id,
        ratting: nextValue,
      };
      FD.callAPI(App_data.backend_api + '/cfa_2_2025question_bank/UpdateCfaRatting', params).then(
        response => {
          if (response.success) {
            this.setState({ rated: 1, ratting_text: 'Rated ' });
          }
        },
      );
    }

    this.setState({ rating: nextValue });
    var params = {
      token: this.state.token,
      question_id: item.id,
      idname: this.state.idname,
    };
    FD.callAPI(App_data.backend_api + '/cfa_2_2025question_bank/getCfaratting', params).then(
      response => {
        if (response.success) {
          if (response.ratting.length > 0) {
            this.setState({ rated: true });
            response.ratting.map(items => {
              this.setState({ rating: items.ratting, ratting_text: 'Rated ' });
            });
          } else {
            var params = {
              token: this.state.token,
              idname: this.state.idname,
              question_id: item.id,
              ratting: nextValue,
            };
            FD.callAPI(
              App_data.backend_api + '/cfa_2_2025question_bank/saveCfaratting',
              params,
            ).then(response => {
              if (response.success) {
                this.setState({ rated: 1, ratting_text: 'Rated ' });
              }
            });
          }
        } else {
          var params = {
            token: this.state.token,
            idname: this.state.idname,
            question_id: item.id,
            ratting: nextValue,
          };
          FD.callAPI(App_data.backend_api + '/cfa_2_2025question_bank/saveCfaratting', params).then(
            response => {
              if (response.success) {
                this.setState({
                  rated: 1,
                  ratting_text: 'Rated ' + nextValue + ' ' + 'stars',
                });
              }
            },
          );
        }
      },
    );
  }

  /*
  --------------------------------------
    Function to show Report box
  -------------------------------------
    */
  _displayReportForm = (item, e) => {
    this.setState({ report_block: 'card show_block' });
  };

  /*
  -------------------------------------------
    Funcion to save new report question
  -------------------------------------------
    */
  _reportQuestion = (item, e) => {
    var comment = document.getElementById('comment').value;
    if (comment.length < 2) {
      return;
    }
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.id,
      comment: comment,
      caseIndex: this.props.params.case_offset,
      city: this.state.user_city,
      country: this.state.user_country,
      state: this.state.user_state,
      continent: this.state.user_continent,
      ip: this.state.user_ip,
    };
    this.setState({
      reportLoading: true,
    });
    FD.callAPI(App_data.backend_api + '/cfa_2_2025question_bank/reportQuestion', data).then(
      resp => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            successAlert: true,
            reportLoading: false,
          });
          document.getElementById('comment').value = '';
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      },
    );
  };

  onClose = e => {
    this.setState({
      report_block: 'card hide_block',
      successAlert: false,
    });
  };

  /*
  ---------------------------------
    Function to hide Report box
  ---------------------------------
  */
  _hideReportForm = (item, e) => {
    this.setState({ report_block: 'card hide_block' });
  };

  /*
  -----------------------------------
    Function to toggle Comment box
  ------------------------------------
  */
  _getToggleComment = (item, e) => {
    cjquery(this.refs['comment_toggle_div']).slideToggle(1000);
  };

  /*
  ------------------------------------
    Function to toggle Flash box
  ------------------------------------
    */
  _getToggleFlash = (item, e) => {
    cjquery(this.refs['flash_toggle_div']).slideToggle(1000);
  };

  /*
  ---------------------------------------------------------------------
    Function to Save flash Card And display new stored flash card
  ---------------------------------------------------------------------
  */
  _saveFlashCard = (item, e) => {
    if (document.getElementById('flash_card').value == '') {
      return;
    }

    var flash_card = document.getElementById('flash_card').value;
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.id,
      flash_card: flash_card,
    };
    FD.callAPI(App_data.backend_api + '/cfa_2_2025question_bank/saveFlashCard', data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true });
        document.getElementById('flash_card').value = '';
        var params = {
          token: this.state.token,
          idname: this.state.idname,
          question_id: item.id,
        };
        FD.callAPI(`${App_data.backend_api}/cfa_2_2025question_bank/getFlashcards`, params).then(
          response => {
            if (response.success) {
              this.setState({ ValidToken: true });

              if (response.flash_cards.length > 0) {
                this.setState({
                  flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
                });
                var flash_cards = response.flash_cards.map((items, index) => (
                  <li key={index}>
                    <div className=''>
                      <ul className='icon_list'>
                        <li>
                          <a className='pointer_class' onClick={this._editFlash.bind(this, items)}>
                            <i className='fa fa-pencil' />
                          </a>
                        </li>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._deleteFlash.bind(this, items)}
                          >
                            <i className='fa fa-close' />
                          </a>
                        </li>
                      </ul>
                      <div className={this.state.flash_class}>
                        <h4 />
                        <p>{items.flash_card}</p>
                      </div>
                    </div>
                  </li>
                ));
              } else {
                this.setState({
                  flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
                });
                var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
              }
              this.setState({ flash_data: flash_cards });
            } else {
              var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
              this.setState({
                ValidToken: false,
                flash_data: flash_cards,
                flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
              });
            }
            return response;
          },
        );
      } else {
        this.setState({ ValidToken: false });
      }
    });
  };

  /*
  ---------------------------------
    Function to Edit Flash card
  ---------------------------------
  */
  _editFlash = (item, e) => {
    this.setState({
      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
    });
    document.getElementById('flash_card').value = item.flash_card;
  };

  /*
  --------------------------------------
     Function to delete flash card
  --------------------------------------
  */
  _deleteFlash = (item, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      flash_card: item,
    };
    FD.callAPI(App_data.backend_api + '/cfa_2_2025question_bank/deleteFlashCard', data).then(
      resp => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
          });
          document.getElementById('flash_card').value = '';
          var flash_cards = <p>No Flash Card Found</p>;
          this.setState({ flash_data: flash_cards });
        } else {
          this.setState({ ValidToken: false });
        }
      },
    );
  };

  getNext = () => {
    const { offset, all_questions_state } = this.state;
    if (offset < all_questions_state.length - 1) {
      const nextOffset = offset + 1;
      const nextQuestion = all_questions_state[nextOffset];

      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }

      this.setState({
        offset: nextOffset,
        display_loader: 'show_block',
        validated: false,
        clicked: false,
        choice_a: 'answer_box',
        choice_b: 'answer_box',
        choice_c: 'answer_box',
        result_block: 'card hide_block',
      });

      const data = {
        token: this.state.token,
        idname: this.state.idname,
        question_id: nextQuestion.id,
      };

      FD.callAPI(`${App_data.backend_api}/cfa_2_2025question_bank/getQuestionsbyid`, data).then((resp) => {
        if (resp.success) {
          const currentQuestion = resp.questionsbyid;
          const selectedChoice = currentQuestion["cfa2_2025_question_stats.selected_choice"] || '';
          const rightAnswer = currentQuestion["cfa2_2025_question_stats.right_answer"] || '';
          const answerStatus = currentQuestion["cfa2_2025_question_stats.id"] || '';
          const timeDone = currentQuestion["cfa2_2025_question_stats.time_done"] || 0;
          const correctChoiceKey = 'answer';
          const { selected, showAnswer } = this.determineSelectedAndShowAnswer(currentQuestion, selectedChoice, answerStatus, rightAnswer, correctChoiceKey);

          this.updateTimerState(selected, timeDone);

          const choiceKeys = ['choice_a', 'choice_b', 'choice_c'];
          const choiceBoxStates = choiceKeys.reduce((acc, choice) => {
            const isSelected = selected === choice;
            const isCorrect = `choice_${currentQuestion[correctChoiceKey]}` === choice;
            acc[choice] = isSelected
              ? isCorrect ? 'answer_box success' : 'answer_box failure'
              : 'answer_box';
            return acc;
          }, {});

          this.setState({
            questions: currentQuestion,
            selectedChoice: selected,
            clicked: !!selected,
            ...choiceBoxStates,
            result_block: showAnswer ? 'card show_block' : 'card hide_block',
            text_color: selected === `choice_${currentQuestion[correctChoiceKey]}` ? 'card-header text_success' : 'card-header text_failure',
            result: selected === `choice_${currentQuestion[correctChoiceKey]}` ? 'CORRECT' : 'INCORRECT',
            display_loader: 'hide_block',
          });

          const favParams = {
            ...data,
            chapter_id: this.props.params.chapterid,
          };
          const flashParams = {
            ...data,
          };

          Promise.all([
            FD.callAPI(`${App_data.backend_api}/cfa_2_2025question_bank/getFavQuestions`, favParams),
            FD.callAPI(`${App_data.backend_api}/cfa_2_2025question_bank/getFlashcards`, flashParams)
          ]).then(([favResp, flashResp]) => {
            const isSavedQuestion = favResp.success;
            const hasFlash = flashResp.success && flashResp.flash_cards && flashResp.flash_cards.length > 0;
            this.setState({
              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
              bookmarkCSS: isSavedQuestion ? 'fa fa-bookmark mark-action-btn-bookmark' : 'fa fa-bookmark-o mark-action-btn-bookmark',
              bookmarkColor: isSavedQuestion ? 'rgb(54, 141, 84)' : '',
              save_text: isSavedQuestion ? `${language.LC().Question_Saved}` : `${language.LC().SAVE_QUESTION}`,
              isFlashCardHidden: !isSavedQuestion,
            });
            if (hasFlash) {
              this.setState({
                flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
                flash_data: flashResp.flash_cards.map((items, index) => (
                  <li key={index}>
                    <div className=''>
                      <ul className='icon_list'>
                        <li>
                          <a className='pointer_class' onClick={this._editFlash.bind(this, items)}>
                            <i className='fa fa-pencil' />
                          </a>
                        </li>
                        <li>
                          <a className='pointer_class' onClick={this._deleteFlash.bind(this, items)}>
                            <i className='fa fa-close' />
                          </a>
                        </li>
                      </ul>
                      <div className={this.state.flash_class}>
                        <h4 />
                        <p>{items.flash_card}</p>
                      </div>
                    </div>
                  </li>
                ))
              });
            } else {
              this.setState({
                flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
                flash_data: <p>{language.LC().NO_FLASHCARD_FOUND}</p>,
              });
            }
          });
        }
      });
    } else {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      this.setState({
        showCompletionQuestion: true,
        timer_stop: true,
        timer_tag: 'Start',
        timerstopbtn: 'pause_btn icon-control-play'
      });
    }
  };

  getSubscribe = () => {
    this.context.router.push({
      pathname: '/subscribe/',
      state: { token: this.state.token, idname: this.state.idname },
    });
  };

  handleTimerResponse(selectedChoice) {
    if (selectedChoice) {
      clearInterval(this.timer);
      this.setState({
        timer_stop: true,
        timer_tag: 'Start',
        timerstopbtn: 'pause_btn icon-control-play'
      });
    } else {
      this.setState({
        timer_stop: false,
        timer_tag: 'Stop',
        timerstopbtn: 'pause_btn icon-control-pause'
      });
      clearInterval(this.timer);
      this.timer = setInterval(this.tick, 1000);
    }
  }

  getPrevious = () => {
    const { offset, all_questions_state } = this.state;

    if (offset > 0) {
      const prevOffset = offset - 1;
      const prevQuestion = all_questions_state[prevOffset];

      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }

      this.setState({
        offset: prevOffset,
        display_loader: 'show_block',
        validated: false,
        clicked: false,
        choice_a: 'answer_box',
        choice_b: 'answer_box',
        choice_c: 'answer_box',
        result_block: 'card hide_block',
      });

      const data = {
        token: this.state.token,
        idname: this.state.idname,
        question_id: prevQuestion.id,
      };

      FD.callAPI(`${App_data.backend_api}/cfa_2_2025question_bank/getQuestionsbyid`, data).then((resp) => {
        if (resp.success) {
          const currentQuestion = resp.questionsbyid;
          const selectedChoice = currentQuestion["cfa2_2025_question_stats.selected_choice"] || '';
          const rightAnswer = currentQuestion["cfa2_2025_question_stats.right_answer"] || '';
          const answerStatus = currentQuestion["cfa2_2025_question_stats.id"] || '';
          const timeDone = currentQuestion["cfa2_2025_question_stats.time_done"] || 0;
          const correctChoiceKey = 'answer';
          const { selected, showAnswer } = this.determineSelectedAndShowAnswer(currentQuestion, selectedChoice, answerStatus, rightAnswer, correctChoiceKey);

          this.updateTimerState(selected, timeDone);

          const choiceKeys = ['choice_a', 'choice_b', 'choice_c'];
          const choiceBoxStates = choiceKeys.reduce((acc, choice) => {
            const isSelected = selected === choice;
            const isCorrect = `choice_${currentQuestion[correctChoiceKey]}` === choice;
            acc[choice] = isSelected
              ? isCorrect ? 'answer_box success' : 'answer_box failure'
              : 'answer_box';
            return acc;
          }, {});

          this.setState({
            questions: currentQuestion,
            selectedChoice: selected,
            clicked: !!selected,
            ...choiceBoxStates,
            result_block: showAnswer ? 'card show_block' : 'card hide_block',
            text_color: selected === `choice_${currentQuestion[correctChoiceKey]}` ? 'card-header text_success' : 'card-header text_failure',
            result: selected === `choice_${currentQuestion[correctChoiceKey]}` ? 'CORRECT' : 'INCORRECT',
            display_loader: 'hide_block',
          });

          const favParams = {
            ...data,
            chapter_id: this.props.params.chapterid,
          };
          const flashParams = {
            ...data,
          };
          Promise.all([
            FD.callAPI(`${App_data.backend_api}/cfa_2_2025question_bank/getFavQuestions`, favParams),
            FD.callAPI(`${App_data.backend_api}/cfa_2_2025question_bank/getFlashcards`, flashParams)
          ]).then(([favResp, flashResp]) => {
            const isSavedQuestion = favResp.success;
            const hasFlash = flashResp.success && flashResp.flash_cards && flashResp.flash_cards.length > 0;
            this.setState({
              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
              bookmarkCSS: isSavedQuestion ? 'fa fa-bookmark mark-action-btn-bookmark' : 'fa fa-bookmark-o mark-action-btn-bookmark',
              bookmarkColor: isSavedQuestion ? 'rgb(54, 141, 84)' : '',
              save_text: isSavedQuestion ? `${language.LC().Question_Saved}` : `${language.LC().SAVE_QUESTION}`,
              isFlashCardHidden: !isSavedQuestion,
            });
            if (hasFlash) {
              this.setState({
                flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
                flash_data: flashResp.flash_cards.map((items, index) => (
                  <li key={index}>
                    <div className=''>
                      <ul className='icon_list'>
                        <li>
                          <a className='pointer_class' onClick={this._editFlash.bind(this, items)}>
                            <i className='fa fa-pencil' />
                          </a>
                        </li>
                        <li>
                          <a className='pointer_class' onClick={this._deleteFlash.bind(this, items)}>
                            <i className='fa fa-close' />
                          </a>
                        </li>
                      </ul>
                      <div className={this.state.flash_class}>
                        <h4 />
                        <p>{items.flash_card}</p>
                      </div>
                    </div>
                  </li>
                ))
              });
            } else {
              this.setState({
                flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
                flash_data: <p>{language.LC().NO_FLASHCARD_FOUND}</p>,
              });
            }
          });
        }
      });
    }
  };

  // Helper to update timer state based on whether a question is selected
  updateTimerState(isSelected, timeDone = 0) {
    if (isSelected) {
      clearInterval(this.timer);
      this.timer = null;
      this.setState({
        timer_stop: true,
        timer_tag: 'Start',
        timerstopbtn: 'pause_btn icon-control-play',
        count: timeDone
      });
    } else {
      if (this.timer) clearInterval(this.timer);
      this.timer = setInterval(this.tick, 1000);
      this.setState({
        timer_stop: false,
        timer_tag: 'Stop',
        timerstopbtn: 'pause_btn icon-control-pause',
        count: 0
      });
    }
  }

  determineSelectedAndShowAnswer(currentQuestion, selectedChoice, answerStatus, rightAnswer, correctChoiceKey) {
    let selected = '';
    let showAnswer = false;
    const isRevisionMode = isRevisionModeActive(EXAM_NAMES.CFA_2);
    if (selectedChoice && isRevisionMode) {
      selected = selectedChoice;
      showAnswer = true;
    } else if (answerStatus && isRevisionMode) {
      if (rightAnswer === 1) {
        selected = `choice_${currentQuestion[correctChoiceKey]}`;
        showAnswer = true;
      } else if (!rightAnswer) {
        const correct = currentQuestion[correctChoiceKey];
        const choices = Object.keys(currentQuestion)
          .filter(key => key.startsWith('choice') && key !== `choice_${correct}`);
        selected = choices.length > 0 ? choices[0] : '';
        showAnswer = true;
      }
    }
    return { selected, showAnswer };
  }
  _getNextCase = () => {
    this.setState({
      display_cases: 'hide_block',
      display_subcription: 'hide_block',
    });
    this.setState({ clicked: false });
    const casesoffset = parseInt(this.state.cases_offset) + 1;
    var caseid = '';
    if (this.state.cases_length > casesoffset) {
      this.setState({ cases_offset: casesoffset });
      caseid = this.state.all_cases[casesoffset].id;
      this.context.router.push({
        pathname: AppRoutes.CFA2_2025_QUESTION_BANK_CASES_QUESTION.replace(
          ':chapterid',
          this.props.params.chapterid,
        )
          .replace(':caseid', caseid)
          .replace(':case_offset', casesoffset)
          .replace(':question_number', 1)
          .replace(':offset', 0),
      });
    } else {
      this.setState({ cases_offset: 0 });
      caseid = this.state.all_cases[0].id;
      this.context.router.push({
        pathname: AppRoutes.CFA2_2025_QUESTION_BANK_CASES_QUESTION.replace(
          ':chapterid',
          this.props.params.chapterid,
        )
          .replace(':caseid', caseid)
          .replace(':case_offset', 0)
          .replace(':question_number', 1)
          .replace(':offset', 0),
      });
    }
  };

  _getPreviousCase = () => {
    this.setState({
      display_cases: 'hide_block',
      display_subcription: 'hide_block',
    });
    this.setState({ clicked: false });
    if (this.state.cases_offset == 0) {
      const casesoffset = this.state.cases_length - 1;
      var caseid = this.state.all_cases[casesoffset].id;
      this.setState({ cases_offset: casesoffset });
      this.context.router.push({
        pathname: AppRoutes.CFA2_2025_QUESTION_BANK_CASES_QUESTION.replace(
          ':chapterid',
          this.props.params.chapterid,
        )
          .replace(':caseid', caseid)
          .replace(':case_offset', casesoffset)
          .replace(':question_number', 1)
          .replace(':offset', 0),
      });
    } else {
      const casesoffset = this.state.cases_offset - 1;
      var caseid = this.state.all_cases[casesoffset].id;
      this.setState({ cases_offset: casesoffset });
      this.context.router.push({
        pathname: AppRoutes.CFA2_2025_QUESTION_BANK_CASES_QUESTION.replace(
          ':chapterid',
          this.props.params.chapterid,
        )
          .replace(':caseid', caseid)
          .replace(':case_offset', casesoffset)
          .replace(':question_number', 1)
          .replace(':offset', 0),
      });
    }
  };

  _changeQuestion(chapterid, caseid, case_offset, question_number, token_id, idname, offset_val) {
    this.setState({ case_id: caseid });
    var data = { token: token_id, idname: idname, chapter_id: chapterid };
    FD.callAPI(App_data.backend_api + '/cfa_2_2025question_bank/getChaptersbyID', data).then(
      resp => {
        if (resp.success) {
          this.setState({
            chaptername: resp.chapterdata.chapter_name,
            chapters: resp.chapterdata,
          });
        } else {
          this.setState({ ValidToken: false });
        }
      },
    );
    FD.callAPI(App_data.backend_api + '/cfa_2_2025question_bank/getCases', data).then(resp => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          choice_a: 'answer_box',
          choice_b: 'answer_box',
          choice_c: 'answer_box',
          result_block: 'card hide_block',
          rated: false,
          rating: 0,
          ratting_text: 'Rate this Question',
          save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
          bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
          save_text: `${language.LC().SAVE_QUESTION}`,
          timerstopbtn: 'pause_btn icon-control-pause',
          report_block: 'card hide_block',
          all_cases: resp.readings,
        });
        for (var i = 0; i < resp.readings.length; i++) {
          if (this.props.params.case_offset == i) {
            this.setState({
              cases_display: resp.readings[i].case,
              cases_name: resp.readings[i].case_name_2025,
            });
          }
        }
        this.setState({ display_loader: 'hide_block' });
        var param = { token: token_id, idname: idname, case_id: caseid };
        FD.callAPI(App_data.backend_api + '/cfa_2_2025question_bank/getCasesquestion', param).then(
          resp_question => {
            if (resp_question.success) {
              this.setState({
                casesquestion_length: resp_question.questions_details.length,
              });
              if (resp_question.questions_details.length > 0) {
                //let ques_res=[];
                const wantedNumber = resolveQuestionNumber(resp_question.questions_details, question_number);
                let offset_res = '';
                var questionid = '';
                for (var i = 0; i < resp_question.questions_details.length; i++) {
                  if (resp_question.questions_details[i].question_number == wantedNumber) {
                    offset_res = i;
                    questionid = resp_question.questions_details[i].id;
                    this.setState({
                      questions: resp_question.questions_details[i],
                    });
                  }
                }
                this.setState({
                  offset: offset_res,
                  all_questions_state: resp_question.questions_details,
                });

                //Api to Fetch saved question stats
                var params_fav = {
                  token: token_id,
                  idname: idname,
                  question_id: questionid,
                  chapter_id: chapterid,
                };
                FD.callAPI(
                  App_data.backend_api + '/cfa_2_2025question_bank/getFavQuestions',
                  params_fav,
                ).then(response => {
                  if (response.success) {
                    this.setState({
                      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
                      bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
                      bookmarkColor: 'rgb(54, 141, 84)',
                      save_text: `${language.LC().Question_Saved}`,
                      isFlashCardHidden: false,
                    });
                  } else {
                    this.setState({ isFlashCardHidden: true });
                  }
                });

                var params = {
                  token: token_id,
                  idname: idname,
                  question_id: questionid,
                };
                //Api to get ratting
                FD.callAPI(
                  App_data.backend_api + '/cfa_2_2025question_bank/getCfaratting',
                  params,
                ).then(response => {
                  if (response.success) {
                    this.setState({ rated: true });
                    response.ratting.map(items => {
                      this.setState({
                        rating: items.ratting,
                        ratting_text: 'Rated ',
                      });
                    });
                  }
                });

                var params = {
                  token: token_id,
                  idname: idname,
                  question_id: questionid,
                };
                var params = {
                  token: token_id,
                  idname: idname,
                  question_id: questionid,
                };
                //Api to fetch flashcard by question id
                FD.callAPI(
                  App_data.backend_api + '/cfa_2_2025question_bank/getFlashCards',
                  params,
                ).then(response => {
                  if (response.success) {
                    this.setState({ ValidToken: true });
                    if (response.flash_cards.length > 0) {
                      this.setState({
                        flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
                      });
                      var flash_cards = response.flash_cards.map((items, index) => (
                        <li key={index}>
                          <div className=''>
                            <ul className='icon_list'>
                              <li>
                                <a
                                  className='pointer_class'
                                  onClick={this._editFlash.bind(this, items)}
                                >
                                  <i className='fa fa-pencil' />
                                </a>
                              </li>
                              <li>
                                <a
                                  className='pointer_class'
                                  onClick={this._deleteFlash.bind(this, items)}
                                >
                                  <i className='fa fa-close' />
                                </a>
                              </li>
                            </ul>
                            <div className={this.state.flash_class}>
                              <h4 />
                              <p>{items.flash_card}</p>
                            </div>
                          </div>
                        </li>
                      ));
                    } else {
                      this.setState({
                        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
                      });
                      var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
                    }
                    this.setState({ flash_data: flash_cards });
                  } else {
                    var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
                    this.setState({
                      ValidToken: false,
                      flash_data: flash_cards,
                      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
                    });
                  }
                  return response;
                });

                this.setState({ records: '' });
              } else {
                console.log('Not Valid');
              }
            }
          },
        );
      } else {
        this.setState({ ValidToken: false, records: 'Result not found.' });
      }
      clearInterval(this.timer);
      this.timer = setInterval(this.tick.bind(this), 1000);
      return resp;
    });
    this.setState({ timer_stop: false, timer_tag: 'Stop', count: 0 });
    clearInterval(this.timer);
    this.timer = setInterval(this.tick.bind(this), 1000);

    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src =
      'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.2/MathJax.js?config=TeX-MML-AM_CHTML'; // use the location of your MathJax

    document.getElementsByTagName('head')[0].appendChild(script);
  }

  _changeCase(chapterid, caseid, case_offset, question_number, token_id, idname, offset_val) {
    var data = { token: token_id, idname: idname };
    FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
      var data = {
        token: token_id,
        idname: idname,
        caseid: this.props.params.caseid,
      };
      // var final_exam = [];
      FD.callAPI(App_data.backend_api + '/cfa_2_2025question_bank/getCasesbyId', data).then(
        resp_cases => {
          if (resp_cases.success) {
            var data = { token: token_id, idname: idname };
            FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
              var free_status = '';
              if (resp.profileInfo.role === 'partner') {
                if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
                  free_status = 'free';
                  this.setState({ subscriptionstatus: 'free' });
                  if (resp_cases.casesingleData.free === 0) {
                    this.setState({
                      display_cases: 'hide_block',
                      display_subcription: 'show_block',
                    });
                    this.toggleAlert();
                  } else {
                    this.setState({
                      display_cases: 'show_block',
                      display_subcription: 'hide_block',
                    });
                  }
                } else {
                  this.setState({
                    cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
                    cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
                  });
                  var data_arr = resp.profileInfo.exam_selected
                    ? JSON.parse(resp.profileInfo.exam_selected)
                    : null;
                  var dataset = {
                    token: token_id,
                    idname: idname,
                    examid: data_arr,
                  };
                  FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
                    async resp_exam => {
                      if (resp_exam.success) {
                        var exam_data = resp_exam.examData;
                        var selectedmen = this.state.selectedmenu;
                        var isInArray_var = false;
                        // #261 — pass examPlanData so mock-only partners hit
                        // the early-return false (was missing here).
                        const examPlanData = resp_exam.examPlan && resp_exam.examPlan[0];
                        isInArray_var = await PartnerCfa2SubscriptionCheck.checkCfa2Subscription(
                          selectedmen,
                          exam_data,
                          this.state.cfaUnlimitedPackage,
                          this.state.cfaUnlimitedActiveExam,
                          examPlanData,
                        );
                        if (isInArray_var) {
                          this.setState({
                            display_cases: 'show_block',
                            display_subcription: 'hide_block',
                          });
                        } else {
                          if (resp_cases.casesingleData.free == 0) {
                            this.setState({
                              display_cases: 'hide_block',
                              display_subcription: 'show_block',
                            });
                          } else {
                            this.setState({
                              display_cases: 'show_block',
                              display_subcription: 'hide_block',
                            });
                          }
                        }
                      } else {
                        console.log('fail');
                      }
                    },
                  );
                }
              } else {
                if (
                  resp.profileInfo.exam_selected == '' &&
                  resp.profileInfo.cfaUnlimitedPackage == '' &&
                  resp.profileInfo.cfaUnlimitedActiveExam == ''
                ) {
                  free_status = 'free';
                  //here code for check case id free or not
                  this.setState({ subscriptionstatus: 'free' });
                  if (resp_cases.casesingleData.free === 0) {
                    this.setState({
                      display_cases: 'hide_block',
                      display_subcription: 'show_block',
                    });
                    this.toggleAlert();
                  } else {
                    this.setState({
                      display_cases: 'show_block',
                      display_subcription: 'hide_block',
                    });
                  }
                } else {
                  this.setState({
                    cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
                    cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
                  });
                  var data_arr = resp.profileInfo.exam_selected
                    ? JSON.parse(resp.profileInfo.exam_selected)
                    : null;
                  var dataset = {
                    token: token_id,
                    idname: idname,
                    examid: data_arr,
                  };
                  FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
                    resp_exam => {
                      if (resp_exam.success) {
                        var exam_data = resp_exam.examData;
                        var selectedmen = this.state.selectedmenu;
                        var isInArray_var = false;
                        isInArray_var = Cfa2SubscriptionCheck.checkCfa2Subscription(
                          selectedmen,
                          exam_data,
                          this.state.cfaUnlimitedPackage,
                          this.state.cfaUnlimitedActiveExam,
                        );
                        if (isInArray_var) {
                          this.setState({
                            display_cases: 'show_block',
                            display_subcription: 'hide_block',
                          });
                        } else {
                          if (resp_cases.casesingleData.free == 0) {
                            this.setState({
                              display_cases: 'hide_block',
                              display_subcription: 'show_block',
                            });
                          } else {
                            this.setState({
                              display_cases: 'show_block',
                              display_subcription: 'hide_block',
                            });
                          }
                        }
                      } else {
                        console.log('fail');
                      }
                    },
                  );
                }
              }
            });
          } else {
            console.log('Cases not avilable');
          }
        },
      );
    });

    this.setState({ case_id: caseid });
    var data = { token: token_id, idname: idname, chapter_id: chapterid };
    FD.callAPI(App_data.backend_api + '/cfa_2_2025question_bank/getChaptersbyID', data).then(
      resp => {
        if (resp.success) {
          this.setState({
            chaptername: resp.chapterdata.chapter_name,
            chapters: resp.chapterdata,
          });
        } else {
          this.setState({ ValidToken: false });
        }
      },
    );
    FD.callAPI(App_data.backend_api + '/cfa_2_2025question_bank/getCases', data).then(resp => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          choice_a: 'answer_box',
          choice_b: 'answer_box',
          choice_c: 'answer_box',
          result_block: 'card hide_block',
          rated: false,
          rating: 0,
          ratting_text: 'Rate this Question',
          save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
          bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
          save_text: `${language.LC().SAVE_QUESTION}`,
          timerstopbtn: 'pause_btn icon-control-pause',
          report_block: 'card hide_block',
        });
        document &&
          document.getElementById('comment') &&
          document.getElementById('comment') &&
          document.getElementById('comment').value
          ? (document.getElementById('comment').value = '')
          : null;

        this.setState({ all_cases: resp.readings });
        for (var i = 0; i < resp.readings.length; i++) {
          if (this.props.params.case_offset == i) {
            this.setState({
              cases_display: resp.readings[i].case,
              cases_name: resp.readings[i].case_name_2025,
            });
          }
        }
        this.setState({ display_loader: 'hide_block' });
        var param = { token: token_id, idname: idname, case_id: caseid };
        FD.callAPI(App_data.backend_api + '/cfa_2_2025question_bank/getCasesquestion', param).then(
          resp_question => {
            if (resp_question.success) {
              this.setState({
                casesquestion_length: resp_question.questions_details.length,
              });
              if (resp_question.questions_details.length > 0) {
                const wantedNumber = resolveQuestionNumber(resp_question.questions_details, question_number);
                let offset_res = '';
                var questionid = '';
                for (var i = 0; i < resp_question.questions_details.length; i++) {
                  if (resp_question.questions_details[i].question_number == wantedNumber) {
                    offset_res = i;
                    questionid = resp_question.questions_details[i].id;
                    // Use determineSelectedAndShowAnswer for answer state
                    const currentQuestion = resp_question.questions_details[i];
                    const selectedChoice = currentQuestion["cfa2_2025_question_stats.selected_choice"] || '';
                    const rightAnswer = currentQuestion["cfa2_2025_question_stats.right_answer"] || '';
                    const answerStatus = currentQuestion["cfa2_2025_question_stats.id"] || '';
                    const timeDone = currentQuestion["cfa2_2025_question_stats.time_done"] || 0;
                    const correctChoiceKey = 'answer';
                    const { selected, showAnswer } = this.determineSelectedAndShowAnswer(currentQuestion, selectedChoice, answerStatus, rightAnswer, correctChoiceKey);

                    this.updateTimerState(selected, timeDone);

                    const choiceKeys = ['choice_a', 'choice_b', 'choice_c'];
                    const choiceBoxStates = choiceKeys.reduce((acc, choice) => {
                      const isSelected = selected === choice;
                      const isCorrect = `choice_${currentQuestion[correctChoiceKey]}` === choice;
                      acc[choice] = isSelected
                        ? (isCorrect ? 'answer_box success' : 'answer_box failure')
                        : (isCorrect ? 'answer_box success' : 'answer_box');
                      return acc;
                    }, {});

                    this.setState({
                      questions: currentQuestion,
                      selectedChoice: selected,
                      clicked: !!selected,
                      ...choiceBoxStates,
                      result_block: showAnswer ? 'card show_block' : 'card hide_block',
                      text_color: selected === `choice_${currentQuestion[correctChoiceKey]}` ? 'card-header text_success' : 'card-header text_failure',
                      result: selected === `choice_${currentQuestion[correctChoiceKey]}` ? 'CORRECT' : 'INCORRECT',
                      display_loader: 'hide_block',
                    });
                    this.handleTimerResponse(selected);
                  }
                }
                this.setState({
                  offset: offset_res,
                  all_questions_state: resp_question.questions_details,
                });
                // ... rest of the code ...

                //Api to Fetch saved question stats
                var params_fav = {
                  token: token_id,
                  idname: idname,
                  question_id: questionid,
                  chapter_id: chapterid,
                };
                FD.callAPI(
                  App_data.backend_api + '/cfa_2_2025question_bank/getFavQuestions',
                  params_fav,
                ).then(response => {
                  if (response.success) {
                    this.setState({
                      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
                      bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
                      bookmarkColor: 'rgb(54, 141, 84)',
                      isFlashCardHidden: false,
                    });
                  } else {
                    this.setState({ isFlashCardHidden: true,  bookmarkColor: '', });
                  }
                });

                var params = {
                  token: token_id,
                  idname: idname,
                  question_id: questionid,
                };
                //Api to get ratting
                FD.callAPI(
                  App_data.backend_api + '/cfa_2_2025question_bank/getCfaratting',
                  params,
                ).then(response => {
                  if (response.success) {
                    this.setState({ rated: true });
                    response.ratting.map(items => {
                      this.setState({
                        rating: items.ratting,
                        ratting_text: 'Rated ',
                      });
                    });
                  }
                });
                var params = {
                  token: token_id,
                  idname: idname,
                  question_id: questionid,
                };
                //Api to fetch flashcard by question id
                FD.callAPI(
                  App_data.backend_api + '/cfa_2_2025question_bank/getFlashCards',
                  params,
                ).then(response => {
                  if (response.success) {
                    this.setState({ ValidToken: true });
                    if (response.flash_cards.length > 0) {
                      this.setState({
                        flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
                      });
                      var flash_cards = response.flash_cards.map((items, index) => (
                        <li key={index}>
                          <div className=''>
                            <ul className='icon_list'>
                              <li>
                                <a
                                  className='pointer_class'
                                  onClick={this._editFlash.bind(this, items)}
                                >
                                  <i className='fa fa-pencil' />
                                </a>
                              </li>
                              <li>
                                <a
                                  className='pointer_class'
                                  onClick={this._deleteFlash.bind(this, items)}
                                >
                                  <i className='fa fa-close' />
                                </a>
                              </li>
                            </ul>
                            <div className={this.state.flash_class}>
                              <h4 />
                              <p>{items.flash_card}</p>
                            </div>
                          </div>
                        </li>
                      ));
                    } else {
                      this.setState({
                        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
                      });
                      var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
                    }
                    this.setState({ flash_data: flash_cards });
                  } else {
                    var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
                    this.setState({
                      ValidToken: false,
                      flash_data: flash_cards,
                      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
                    });
                  }
                  return response;
                });
                this.setState({ records: '' });
              } else {
                console.log('Not Valid');
              }
            }
          },
        );
      } else {
        this.setState({ ValidToken: false, records: 'Result not found.' });
      }
      clearInterval(this.timer);
      this.timer = setInterval(this.tick.bind(this), 1000);
      return resp;
    });
    this.setState({ timer_stop: false, timer_tag: 'Stop', count: 0 });
    clearInterval(this.timer);
    this.timer = setInterval(this.tick.bind(this), 1000);
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.params.question_number != this.props.params.question_number &&
      nextProps.params.caseid == this.props.params.caseid
    ) {
      this._changeQuestion(
        nextProps.params.chapterid,
        nextProps.params.caseid,
        nextProps.params.case_offset,
        nextProps.params.question_number,
        this.state.token,
        this.state.idname,
        nextProps.params.offset,
      );
      this.setState({ display_loader: 'show_block' });
    }

    if (nextProps.params.caseid != this.props.params.caseid) {
      this._changeCase(
        nextProps.params.chapterid,
        nextProps.params.caseid,
        nextProps.params.case_offset,
        nextProps.params.question_number,
        this.state.token,
        this.state.idname,
        nextProps.params.offset,
      );
      this.setState({ display_loader: 'show_block' });
    }
  }
  render() {
    const { questions, isFlashCardHidden } = this.state;
    let questions_data_display = questions;

    const { reportLoading } = this.state;
    const choice_a = 'a';
    const choice_b = 'b';
    const choice_c = 'c';
    let forumData = '';
    let count_temp_var = this.state.count;
    let display_time = '';
    if (count_temp_var < 60) {
      display_time = count_temp_var + 'sec';
    } else {
      var temp_min = Math.trunc(count_temp_var / 60);
      var temp_sec = Math.trunc(count_temp_var % 60);
      display_time = temp_min + 'min ' + temp_sec + 'sec';
    }
    let data,
      question_data = '';
    forumData = `<div class='col-sm-12 no-cursor'>
        <div class='margin_bottom_40'>
          <div>
            <div class='row'>
              <div class='col-sm-12'>
                <div class='row no-cursor'>
                  <div class='col-sm-12 cursor-text'>
                    <div
                      contentEditable='false'
                      class='margin_bottom_40 view_questionhtml bg_blue '
                    >                      
                      ${questions_data_display.question}
                    </div>
                  </div>
                  <div class='col-sm-12 no-cursor' id='choice_a'>
                    <div class='answer_box_forum'>
                      <div class='answer_count'>${language.LC().A}</div>
                      <p class='ans_box_text'>
                        <span contentEditable='false'>                          
                          ${questions_data_display.choice_a}
                        </span>
                      </p>
                    </div>
                  </div>

                  <div class='col-sm-12 no-cursor' id='choice_b'>
                    <div class='answer_box_forum'>
                      <div class='answer_count'>${language.LC().B}</div>
                      <p class='ans_box_text'>
                        <span contentEditable='false'>                          
                          ${questions_data_display.choice_b}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div
                    class='col-sm-12 margin_bottom_30 no-cursor'
                    id='choice_c'
                  >
                    <div class='answer_box_forum'>
                      <div class='answer_count'>${language.LC().C}</div>
                      <p class='ans_box_text'>
                        <span contentEditable='false'>
                          ${questions_data_display.choice_c}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div class='col-sm-12 cursor-text'>
                    <p contentEditable='false' class='view_questionhtml'>
                    The correct answer is  ${questions_data_display.answer === 'choice_a'
        ? `<strong> A.</strong>`
        : questions_data_display.answer === 'choice_b'
          ? `<strong> B.</strong>`
          : questions_data_display.answer === 'choice_c'
            ? `<strong> C.</strong>`
            : `<strong> C.</strong>`
      } <br/>
                    ${questions_data_display.explanation}
                    </p>
                  </div>
                  <div class='col-sm-12 margin_bottom_30 no-cursor'>
                    <div className='userQuestionDiv'>
                      <span className='questionColor cursor-text'>                        
                        *User Question:
                      </span>
                      <div className='forum-data-comment cursor-text'>
                        <h4> ${this.state.forumComment}</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>`;
    data = (
      <div className='col-sm-12 col-md-12 note-section'>
        <div className='card note-section-header '>
          <div className='card-header title-font-size'>
            {this.state.cases_name}
            <div className='float-right text-right'>
              <i
                className='fa fa-angle-left ques_arrow pointer_class'
                onClick={this._getPreviousCase}
              />
              <i
                className='fa fa-angle-right ques_arrow pointer_class'
                onClick={this._getNextCase}
              />
            </div>
          </div>
          <div className={'card-block note_text_wrap ' + this.state.display_cases}>
            <div className='row'>
              <div className='col-sm-12 col-md-12 '>
                {renderHTMLContent(this.state.cases_display, "span", "", { contentEditable: "false", suppressContentEditableWarning: true })}
              </div>
            </div>
          </div>
        </div>
      </div>
    );

    {
      this.state.showCompletionQuestion
        ? (question_data = (
          <div className='w-100'>
            <div className={'card-block ' + this.state.display_subcription}>
              <div className='row'>
                <div className='col-md-12'>
                  <div className='card'>
                    <span>{language.LC().THIS_CASE_IS_AVAILABLE_FOR_PREMIUM_MEMBERS_ONLY}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className={'col-md-12 complete-section-wrap ' + this.state.display_cases}>
              <div className='card'>
                <div className='card-header text-center'>
                  {/* <img src={App_data.frontend_url+"/img/question_bank/question_icon_blue.svg"} className="margin_right_20" alt="" width="30" /> */}
                  {language.LC().Mark_this_Question_as_Completed}
                  {/* <button onClick = {this.getNextAnyway} > Go To Question 1 </button> */}
                  <div onClick={this.getNextAnyway} className='float-right text-right'>
                    <i className='fa fa-angle-right ques_arrow pointer_class' />
                  </div>
                </div>

                <div className='card-block'>
                  <div className='row'>
                    <div className='col-sm-12 text-center'>
                      <div className='row'>
                        <div className='col-sm-12 col-md-12 '>
                          <div className='quation-img'>
                            <img
                              src={
                                App_data.frontend_url +
                                '/img/question_bank/question_icon_blue.svg'
                              }
                              className='margin_bottom_10'
                              alt=''
                            />
                          </div>
                          <div
                            contentEditable='false'
                            suppressContentEditableWarning={true}
                            className='margin_bottom_10 view_questionhtml bg_blue'
                          >
                            {' '}
                            {language.LC().MARK_THIS_QUESTION_AS_COMPLETED}{' '}
                          </div>
                        </div>
                        <div className='complete-or-not-wrap'>
                          <div className='check-button-wrap'>
                            <div className='card-actions float-right'>
                              <label className='check_container margin_bottom_0'>
                                {' '}
                                {language.LC().COMPLETED}
                                <input
                                  type='checkbox'
                                  id='mark_completed'
                                  name='mark_completed'
                                  value='select'
                                  onClick={this.markCompleted.bind(this)}
                                  checked={this.state.markAsCompleted}
                                />
                                <span className='checkmark' />
                              </label>
                            </div>
                            <div className='card-actions float-right'>
                              <label className='check_container margin_bottom_0'>
                                {language.LC().NOT_COMPLETED}
                                <input
                                  type='checkbox'
                                  id='mark_not_completed'
                                  name='mark_not_completed'
                                  value='select'
                                  onClick={this.markNotCompleted.bind(this)}
                                  checked={this.state.markAsNotCompleted}
                                />
                                <span className='checkmark' />
                              </label>
                            </div>
                          </div>
                          <div className='d-block text-center complete-quation-submit'>
                            <button
                              disabled={this.state.markCompleted}
                              onClick={this.changeCompletionStatus.bind(this)}
                              className='btn btn-primary pointer_class'
                            >
                              {' '}
                              {language.LC().SUBMIT}{' '}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))
        : (question_data = (
          <div className='note-section'>
            <div className={'card-block ' + this.state.display_subcription}>
              <div className='row'>
                <div className='col-sm-12 col-md-12'>
                  <div className='card'>
                    <div className='card-header'>
                      <h4>{language.LC().THIS_CASE_IS_AVAILABLE_FOR_PREMIUM_MEMBERS_ONLY}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={'col-sm-12 col-md-12 ' + this.state.display_cases}>
              <div className='card font-lusitana'>
                <div className='card-header'>
                  <img
                    src={App_data.frontend_url + '/img/question_bank/question_icon_blue.svg'}
                    className='margin_right_20'
                    alt=''
                    width='30'
                  />
                  {language.LC().QUESTION} {questionDisplayNumber(questions_data_display, this.state.offset) + ' - '}
                  <div className='float-right text-right'>
                    <i
                      className={'fa fa-angle-left ques_arrow pointer_class '}
                      onClick={this.getPrevious}
                    />
                    <i
                      className={'fa fa-angle-right ques_arrow pointer_class '}
                      onClick={this.getNext}
                    />
                  </div>
                </div>
                <div className='card-block'>
                  <div className='row'>
                    <div className='col-sm-9'>
                      <ViewQuestion
                        {...questions_data_display}
                        {...this.props}
                        setAnswer={this._getAnswer}
                        showAnswer={this.state.clicked}
                        correctChoice={`choice_${questions_data_display.answer}`}
                        selectedChoice={this.state.selectedChoice}
                        onValidate={() => this.getResult(questions_data_display)}
                      >
                        <Col md={12} className="mt-2">
                          <Row className="align-items-center">
                            <div className='d-flex align-items-center'>
                              <ValidateSaveReportIcon
                                isQue={true}
                                _getResult={this.getResult}
                                clicked={this.state.clicked}
                                _saveQuestion={this._saveQuestion}
                                _displayReportForm={this._displayReportForm}
                                all_questions={questions_data_display}
                                save_text={this.state.save_text}
                                bookmarkCSS={this.state.bookmarkCSS}
                                bookmarkColor={this.state.bookmarkColor}
                                disabled={!this.state.selectedChoice || this.state.clicked}
                              />
                            </div>
                          </Row>
                        </Col>
                      </ViewQuestion>
                    </div>
                    <div className='col-sm-3'>
                      <div className='timer_outer'>
                        <i className='fa fa-clock-o' />
                        <span className='timer_box'>{display_time}</span>
                      </div>

                      <button
                        type='button'
                        className={this.state.timerstopbtn}
                        onClick={this._timer_funct.bind(this, questions_data_display)}
                      >
                        {/*this.state.timer_tag*/}
                      </button>
                      {this.state.subscriptionstatus == 'free' ? (
                        <a
                          onClick={this.getSubscribe}
                          className='box_question_color text-center cursor_pointer'
                        >
                          <p className='margin_bottom_0'>
                            {' '}
                            {language.LC().SUBSCRIBE_FOR_1500_PRACTICE_QUESTIONS}{' '}
                          </p>
                        </a>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className={`${this.state.result_block} font-lusitana font-16px`}>
                <div className={this.state.text_color}>{this.state.result}</div>
                <div className='card-block'>
                  {/* <Latex>{questions_data_display.explanation}</Latex>   */}
                  {renderHTMLContent(questions_data_display.explanation, "p", "view_questionhtml", { contentEditable: "false", suppressContentEditableWarning: true })}
                </div>
              </div>

              <div className='row'>
                <div className='col-md-12'>
                  <div className={this.state.report_block}>
                    <div className='card-header'>
                      {language.LC().REPORT}
                      {/* <TooltipItem
                          key="1"
                          id="1"
                          content={this.state.tooltips[1].placement}
                          place_tip={this.state.tooltips[1].text_align}
                        /> */}
                    </div>

                    {!this.state.successAlert ? (
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-sm-12'>
                            <label className='form-control-label' htmlFor='textarea-input'>
                              <strong>{language.LC().COMMENT}</strong>
                            </label>
                          </div>
                          <div className='col-sm-12 margin_bottom_10'>
                            <textarea
                              id='comment'
                              name='comment'
                              rows='6'
                              className='form-control'
                              placeholder='Content..'
                            />
                          </div>
                        </div>
                        <div className='row'>
                          <div className='col-sm-12'>
                            <button
                              type='button'
                              className='btn btn-primary active pointer_class margin_bottom_20 report-btn'
                              disabled={reportLoading}
                              onClick={this._reportQuestion.bind(this, questions_data_display)}
                            >
                              {reportLoading ? language.LC().PLEASE_WAIT : language.LC().REPORT}
                            </button>
                            <button
                              type='button'
                              className='btn btn-danger active pointer_class margin_left_10 margin_bottom_20'
                              onClick={this._hideReportForm.bind(this, questions_data_display)}
                            >
                              {language.LC().CANCEL}
                            </button>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-sm-12 report-Success-card'>
                            <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                            <label className='form-control-label' htmlFor='textarea-input'>
                              <strong> {language.LC().REPORT_SEND_SUCCESS_MESSAGE}</strong>
                            </label>
                            <button
                              type='button'
                              className='btn btn-primary active pointer_class  min-vw-120'
                              onClick={this.onClose}
                            >
                              {' '}
                              {language.LC().CLOSE}
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <FlashCard
                item={questions}
                type='question'
                isFlashCardHidden={isFlashCardHidden}
                ref={this.setChildRef}
                exam='cfa2_2025'
              />
            </div>
          </div>
        ));
    }

    return (
      <div className='animated fadeIn'>
        <div className='row note-section'>
          <div className='col-sm-8 margin_bottom_20'>
            <h1 className='section_head title-font-size'>
              {language.LC().CASE_STUDY} - {this.state.chaptername}
            </h1>
          </div>
          <div className='col-sm-4 margin_bottom_20 text-sm-right'>
            <button
              type='button'
              className='btn btn-primary pointer_class'
              onClick={this._getReadings}
            >
              {' '}
              {language.LC().CHANGE_CASES}
            </button>
          </div>
        </div>
        <div className={'row'}>
          {data}
          {question_data}
        </div>
        <div className={'loader_box ' + this.state.display_loader}>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
        <ModalComponent
          goPremium={this.goPremium.bind(this)}
          toggleAlert={this.toggleAlert.bind(this)}
          alert_status={this.state.alert_status}
          MessageContent={this.state.MessageContent}
          exam={examNameAccordingToDB.CFA_2}
        />
      </div>
    );
  }
}

class TooltipItem extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      tooltipOpen: false,
    };
  }

  toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen,
    });
  }

  render() {
    return (
      <span>
        <img
          src={App_data.frontend_url + '/img/dashboard/info_icon.svg'}
          id={'Tooltip-' + this.props.id}
          width='18'
          alt=''
          style={{ marginLeft: '4px' }}
        />
        {/*<i className="fa fa-info-circle"  id={'Tooltip-' + this.props.id} ></i>*/}

        <Tooltip
          placement={this.props.place_tip}
          isOpen={this.state.tooltipOpen}
          target={'Tooltip-' + this.props.id}
          toggle={this.toggle}
        >
          <p className='tooltip_text'>{this.props.content}</p>
        </Tooltip>
      </span>
    );
  }
}

export default Cfa22023chapter;



// WEBPACK FOOTER //
// ./src/views/CFA2-2025/QuestionBank/Cfa2chapter.js